import { QueryHookOptions } from '@apollo/client';
import { getSelectOptions } from '@anytag/shared-utils';
import { Query, useAllAdvertisersForAnalyticsSearchQuery } from '@anytag/graphql';

export const useAllAdvertisersForAnalyticsSearchOptions = (options?: QueryHookOptions<Query>) => {
  const { data, loading } = useAllAdvertisersForAnalyticsSearchQuery({ fetchPolicy: 'cache-and-network', ...options });

  const allAdvertisersOptions = data?.allAdvertisersForSearch
    ? getSelectOptions(data.allAdvertisersForSearch.advertisers)
    : [];

  return { loading, allAdvertisersOptions };
};
